import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PortfolioAgeActivePage = lazy(() => import('./PortfolioAgeActivePage'));

const path = 'reports/age/live';
const PortfolioAgeActiveRoute: FuseRouteItemType = {
	path: path,
	element: <PortfolioAgeActivePage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Portfolio Age',
					helpName: 'Age Live',
					showTitle: false,
					showCrumbs: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default PortfolioAgeActiveRoute;
